import React, { useState, useEffect } from "react";
import axios from "axios";

import Header_titleEn from "../controls/Header_titleEn";
import Footer_last from "../controls/Footer_last";

import {
  Layout,
  Row,
  Col,
  Space,
  Card,
  Divider,
  PageHeader,
  List,
  Table,
  Typography
} from "antd";

import { createGlobalStyle } from "styled-components";

import ThIcon from "../pics/th_icon.png";
import EnIcon from "../pics/en_icon.png";
import Logo from "../pics/RIHES-Logo1.png";

const { Content } = Layout;
const { Text } = Typography;

const StyledForm = createGlobalStyle`.ant-form-item {
    margin-bottom: 5px;
  }
  `;

const Research_rihes_detail_en = () => {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3002/api/";
  } else {
    xURL = "https://research.rihes.cmu.ac.th/api/";
  }

  const [xLng, _xLng] = useState();
  const [xRid, _xRid] = useState();

  const [dataSource, _dataSource] = useState([]);
  const [dataSource1, _dataSource1] = useState([]);
  const [dataSource2, _dataSource2] = useState([]);
  const [dataSource3, _dataSource3] = useState([]);

  const [xTopic, _xTopic] = useState([]);
  const [xScopusNum, _xScopusNum] = useState();

  const [pageTable, _pageTable] = useState(1);
  const [pageSizeTable, _pageSizeTable] = useState(10);

  useEffect(() => {
    var url = new URL(window.location.href);

    if (url.searchParams.get("pages") == "IDSU") {
      _xLng("IDSU");
    } else if (url.searchParams.get("pages") == "CMBI") {
      _xLng("CMBI");
    } else if (url.searchParams.get("pages") == "NINE") {
      _xLng("NINE");
    } else if (url.searchParams.get("pages") == "SHSR") {
      _xLng("SHSR");
    }

    _xRid(url.searchParams.get("rid"));
    Getdata(url.searchParams.get("rid"));
    Getscopus(url.searchParams.get("rid"));
    Getpatent(url.searchParams.get("rid"));
    Getaward(url.searchParams.get("rid"));
  }, []);

  const Getdata = zdata => {
    axios
      .post(xURL + "getResearch_rihes_detail_en", {
        rid: zdata
      })
      .then(result => {
        const Tb1 = [];

        let xresearcher_expertise = "",
          xresearch_topic_eng = "",
          xpositionex = "";

        if (result.data[0].research_topic_eng) {
          if (result.data[0].research_topic_eng.split("|").length > 0) {
            xresearch_topic_eng = result.data[0].research_topic_eng.split("|");
          } else {
            xresearch_topic_eng = result.data[0].research_topic_eng;
          }

          _xTopic(xresearch_topic_eng);
        } else {
          _xTopic(["-"]);
        }

        result.data.forEach((i, idx) => {
          if (!i.researcher_expertise) {
            xresearcher_expertise = ["-"];
          } else {
            if (i.researcher_expertise.split("|").length > 0) {
              xresearcher_expertise = i.researcher_expertise.split("|");
            } else {
              xresearcher_expertise = i.researcher_expertise;
            }
          }

          if (!i.positionex) {
            xpositionex = ["-"];
          } else {
            if (i.positionex.split("|").length > 0) {
              xpositionex = i.positionex.split("|");
            } else {
              xpositionex = i.positionex;
            }
          }

          Tb1.push({
            key: idx,
            id: i.id,
            name: i.name,
            position: i.position,
            position_aca: i.position_aca,
            positionex: xpositionex,
            email: i.email,
            researcher_expertise: xresearcher_expertise,
            picname: i.picname,
            research_topic_eng: i.research_topic_eng,
            ORCID: i.ORCID,
            scopus_id: i.scopus_id,
            h_index_link: i.h_index_link
          });
        });

        _dataSource(Tb1);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Getscopus = zdata => {
    axios
      .post(xURL + "getResearch_scopus", {
        rid: zdata
      })
      .then(result => {
        const Tb1 = [];
        let sumscopus = 0;

        result.data.forEach((i, idx) => {
          Tb1.push({
            key: idx,
            no: idx + 1,
            title: i.title,
            year: i.year,
            link: i.link
          });

          sumscopus = sumscopus + 1;
        });

        _dataSource1(Tb1);
        _xScopusNum(sumscopus);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Getpatent = zdata => {
    axios
      .post(xURL + "getResearch_patent", {
        rid: zdata,
        lang: "en"
      })
      .then(result => {
        const Tb1 = [];
        let xtype = "";

        result.data.forEach((i, idx) => {
          if (i.patent_type == 1) {
            xtype = "petty patent";
          } else if (i.patent_type == 2) {
            xtype = "patent";
          }

          Tb1.push({
            key: idx,
            no: idx + 1,
            patent_name: i.patent_name_eng,
            patent_type: xtype
          });
        });

        _dataSource2(Tb1);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Getaward = zdata => {
    axios
      .post(xURL + "getResearch_award", {
        rid: zdata,
        lang: "en"
      })
      .then(result => {
        const Tb1 = [];

        result.data.forEach((i, idx) => {
          Tb1.push({
            key: idx,
            no: idx + 1,
            award: i.award_description_eng,
            year: i.award_year
          });
        });

        _dataSource3(Tb1);
        // console.log(Tb1);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const columns1 = [
    {
      title: "No.",
      dataIndex: "no",
      key: "no",
      align: "center",
      width: 100
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 800,
      render(text, record, index) {
        return {
          children: (
            <a
              onClick={e => {
                //console.log("corresponding email is :", record.cmumis_id);
                window.open(record.link, "_blank");
              }}
            >
              {text}
            </a>
          )
        };
      }
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      align: "center",
      width: 200
    }
  ];

  const columns2 = [
    {
      title: "No.",
      dataIndex: "no",
      key: "no",
      align: "center",
      width: 100
    },
    {
      title: "Title",
      dataIndex: "patent_name",
      key: "patent_name",
      width: 800
    },
    {
      title: "Type",
      dataIndex: "patent_type",
      key: "patent_type",
      align: "center",
      width: 200
    }
  ];

  const columns3 = [
    {
      title: "No.",
      dataIndex: "no",
      key: "no",
      align: "center",
      width: 100
    },
    {
      title: "Award",
      dataIndex: "award",
      key: "award",
      width: 800
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      align: "center",
      width: 200
    }
  ];

  const pageOnChange = (zpage, zpageSize) => {
    _pageTable(zpage);
    _pageSizeTable(zpageSize);
  };

  const profile = dataSource.length > 0 ? dataSource[0] : null;

  return (
    <React.Fragment>
      <StyledForm />

      {/* <Header_titleEn
        tname={localStorage.getItem("tname")}
        research_id={localStorage.getItem("research_id")}
      /> */}

      <Content
        className="site-layout"
        style={{ padding: "0 20px", marginTop: 64 }}
      >
        <style>
          @import
          url('https://fonts.googleapis.com/css2?family=Bai+Jamjuree:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&display=swap');
        </style>

        {xLng == "IDSU"
          ? <div
              style={{
                marginRight: "100px",
                marginTop: "-40px",
                marginBottom: "30px"
              }}
            >
              <img src={Logo} alt="logo_icon" width="250" height="100" />
            </div>
          : <div />}

        <div
          style={{ float: "right", marginRight: "50px", marginTop: "-40px" }}
        >
          <Space>
            <p
              style={{
                fontSize: "16px",
                marginBottom: "5px",
                fontFamily: "Bai Jamjuree",
                fontWeight: "600"
              }}
            >
              language :
            </p>
            <div className="img-lang">
              <img
                src={ThIcon}
                alt="th_icon"
                width="40"
                height="40"
                style={{ opacity: "0.3" }}
                onClick={() => {
                  window.open(
                    "/Research_rihes_detail_th?pages=" + xLng + "&rid=" + xRid,
                    "_self"
                  );
                }}
              />
            </div>

            <div className="img-lang">
              <img
                className="img-lang"
                src={EnIcon}
                alt="en_icon"
                width="40"
                height="40"
                onClick={() => {
                  window.open(
                    "/Research_rihes_detail_en?pages=" + xLng + "&rid=" + xRid,
                    "_self"
                  );
                }}
              />
            </div>
          </Space>
        </div>

        <div style={{ height: "10px" }} />
        <Divider />

        <div style={{ margin: "0 20px" }}>
          {profile &&
            <Card
              style={{
                borderRadius: 16,
                margin: "0 20px 24px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.08)"
              }}
            >
              <Row gutter={[24, 24]} align="top">
                {/* รูป */}
                <Col xs={24} md={6} style={{ textAlign: "center" }}>
                  <img
                    src={`${xURL}file_research/${profile.picname}`}
                    alt="profile"
                    style={{
                      width: 170,
                      height: 235,
                      objectFit: "cover",
                      borderRadius: 12
                    }}
                  />
                </Col>

                {/* ข้อมูล */}
                <Col xs={24} md={18}>
                  <Typography.Title level={4} style={{ marginBottom: 8 }}>
                    {profile.name}
                  </Typography.Title>
                  <Text strong>Position :</Text> {profile.position}
                  <br />
                  <Text strong>Academic Position :</Text> {profile.position_aca}
                  <br />
                  {profile.positionex &&
                    profile.positionex[0] !== "-" &&
                    <div>
                      <Text strong>Management Position :</Text>
                      <ul style={{ marginTop: 4 }}>
                        {profile.positionex.map((p, i) =>
                          <li key={i}>
                            {p}
                          </li>
                        )}
                      </ul>
                    </div>}
                  <Divider style={{ margin: "12px 0" }} />
                  <Text strong>Email :</Text> {profile.email}
                  <br />
                  {profile.researcher_expertise &&
                    profile.researcher_expertise[0] !== "-" &&
                    <div style={{ marginTop: 6 }}>
                      <div
                        style={{
                          marginTop: 6,
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 6
                        }}
                      >
                        {profile.researcher_expertise &&
                          profile.researcher_expertise[0] !== "-" &&
                          <div style={{ marginTop: 6 }}>
                            <Text strong>Expertise :</Text>

                            <ul style={{ marginTop: 6, paddingLeft: 20 }}>
                              {profile.researcher_expertise.map(
                                (exp, i) =>
                                  i > 0
                                    ? <li key={i} style={{ marginBottom: 6 }}>
                                        {exp}
                                      </li>
                                    : <div />
                              )}
                            </ul>
                          </div>}
                      </div>
                    </div>}
                  <br />
                  <Text strong>ORCID :</Text> {profile.ORCID || "-"}
                  <br />
                  <Text strong>Scopus Author ID :</Text>{" "}
                  {profile.scopus_id || "-"}
                  <br />
                  {profile.h_index_link &&
                    <a
                      onClick={() =>
                        window.open(profile.h_index_link, "_blank")}
                      style={{
                        fontStyle: "italic",
                        fontWeight: 600,
                        display: "inline-block",
                        marginTop: 6
                      }}
                    >
                      Scopus Profile (h-index)
                    </a>}
                </Col>
              </Row>
            </Card>}
        </div>

        <br />

        <div style={{ margin: "0 20px" }}>
          <Card
            style={{
              margin: "0 20px 24px",
              borderRadius: 16
            }}
          >
            <Typography.Title level={5}>
              Current research topics / Research interests
            </Typography.Title>

            <ul>
              {xTopic.map(
                (item, i) =>
                  item &&
                  <li key={i} style={{ marginBottom: 6 }}>
                    {item}
                  </li>
              )}
            </ul>
          </Card>

          <Card
            style={{
              margin: "0 20px 24px",
              borderRadius: 16
            }}
          >
            <Typography.Title level={5}>
              Scopus <b>{xScopusNum}</b> documents
            </Typography.Title>

            <Table
              bordered
              size="small"
              scroll={{ x: "max-content" }}
              dataSource={dataSource1}
              columns={columns1}
              pagination={{
                current: pageTable,
                pageSize: pageSizeTable,
                onChange: pageOnChange
              }}
            />
          </Card>

          {dataSource2.length > 0 &&
            <Card style={{ margin: "0 20px 24px", borderRadius: 16 }}>
              <Typography.Title level={5}>
                Intellectual property
              </Typography.Title>
              <Table
                bordered
                size="small"
                pagination={false}
                dataSource={dataSource2}
                columns={columns2}
              />
            </Card>}

          {dataSource3.length > 0 &&
            <Card style={{ margin: "0 20px", borderRadius: 16 }}>
              <Typography.Title level={5}>Award</Typography.Title>
              <Table
                bordered
                size="small"
                pagination={false}
                dataSource={dataSource3}
                columns={columns3}
              />
            </Card>}
        </div>
      </Content>

      <div style={{ height: "100px" }} />
      {/* 
      <div style={{ height: "200px" }} />

      <Footer_last /> */}
    </React.Fragment>
  );
};

export default Research_rihes_detail_en;
